import { useEffect, useState } from 'react';
import { TextField, Box } from '@mui/material';

import * as S from './styles';
import ExtratoList from '../Extrato/components/ExtratoList';
import PrimaryCard from './components/PrimaryCard';
import SecondaryCard from './components/SecondaryCard';

import { HomePageBanner } from './components/HomePageBanner';
import { RootStateCarteira } from '../../store/carteiraReducer';

import { _UserData, UserDataBaseEnum } from 'base/src/infra/storage/localStorage';
import { GetExtrato } from '../../store/extrato/actions/extratoAction';
import { Icon } from '@iconify/react';
import { GetCarteiraUsuario, GetCarteiraBase, GetCarteiraBasePorCampanha, UpdateCarteiraBase } from 'domain/store/_carteira/carteiraBase/actions/carteiraBaseAction';
import { useTheme } from 'base/src/utils/context/themeContext';
import { Button } from 'base/src/components/Button';

import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { Redirect } from 'base/src/utils/routeUtil';
import { GetAuthRoute } from 'domain/types/sistema/sistemaList';

const connector = connectUtil(
  (state: RootStateCarteira) => ({
    homeInfo: state.CarteiraBaseReducer.CarteiraBase,
    homeInfoCampanha: state.CarteiraBaseReducer.CarteiraBaseCampanha,
    CarteiraUsuario: state.CarteiraBaseReducer.CarteiraUsuario,
    ExtratoRange: state.ExtratoReducer.Extrato,
  }),
  { GetCarteiraBase, UpdateCarteiraBase, GetCarteiraBasePorCampanha, GetCarteiraUsuario, GetExtrato }
);

export interface CarteiraHomeComponentProps extends PropsFromRedux<typeof connector> {
}

function HomePage(props: CarteiraHomeComponentProps) {
  const _userData = _UserData;
  const { theme } = useTheme();

  function toLocalDateString(date: Date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const getDefaultStartDate = () => {
    const weekAgo = new Date();
    weekAgo.setDate(weekAgo.getDate() - 7);
    return toLocalDateString(weekAgo);
  };

  const getDefaultEndDate = () => {
    return toLocalDateString(new Date());
  };

  const [dateStart, setDateStart] = useState(getDefaultStartDate());
  const [dateEnd, setDateEnd] = useState(getDefaultEndDate());

  function fetchExtrato() {
    if (!props.CarteiraUsuario?.length || props.CarteiraUsuario[0].CarteiraID === 0) return;

    const request = {
      From: dateStart ? new Date(dateStart + 'T00:00:00').toDateString() : '',
      To: dateEnd ? new Date(dateEnd + 'T00:00:00').toDateString() : '',
    };

    props.GetExtrato(request, props.CarteiraUsuario[0].CarteiraID, () => { });
  }

  function handleApplyDateFilter() {
    fetchExtrato();
  }

  useEffect(function initializeUserData() {
    props.GetCarteiraUsuario(() => { Redirect(GetAuthRoute()) });
  }, []);

  useEffect(function fetchInitialExtrato() {
    fetchExtrato();
  }, [props.CarteiraUsuario]);

  return (
    <S.Container>
      <S.BannerContainer>
        <HomePageBanner userName={_userData.Get(UserDataBaseEnum.NomeExibicao)} />
      </S.BannerContainer>
      <PrimaryCard />
      <SecondaryCard />
      {/*<TertiaryCard />*/}
      <S.ExtratoContainer>
        <S.HeaderContainer>
          <S.Subtitle>Últimas movimentações</S.Subtitle>
          <S.ExtratoLink>
            <S.StyledLink to='/extrato'>Verificar extrato completo</S.StyledLink>
            <Icon icon="ph:arrow-square-out-bold" width={16} color={theme.colors.primary} />
          </S.ExtratoLink>
        </S.HeaderContainer>

        <S.DateFilterContainer>
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-end', flexWrap: 'wrap' }}>
            <TextField
              label="Data Inicial"
              type="date"
              size="small"
              value={dateStart}
              onChange={(e) => setDateStart(e.target.value)}
              slotProps={{ inputLabel: { shrink: true } }}
              sx={{
                minWidth: '150px',
                flex: 1,
                maxWidth: '200px',
                '& .MuiOutlinedInput-root': {
                  backgroundColor: theme.colors.card,
                  '&:hover fieldset': {
                    borderColor: theme.colors.primary,
                  },
                },
              }}
            />
            <TextField
              label="Data Final"
              type="date"
              size="small"
              value={dateEnd}
              onChange={(e) => setDateEnd(e.target.value)}
              slotProps={{ inputLabel: { shrink: true } }}
              sx={{
                minWidth: '150px',
                flex: 1,
                maxWidth: '200px',
                '& .MuiOutlinedInput-root': {
                  backgroundColor: theme.colors.card,
                  '&:hover fieldset': {
                    borderColor: theme.colors.primary,
                  },
                },
              }}
            />
            <Button
              size="sm"
              variant="primary"
              onClick={handleApplyDateFilter}
            >
              <Icon icon="ph:funnel-bold" height={16} />
              Filtrar
            </Button>
          </Box>
        </S.DateFilterContainer>

        {props.ExtratoRange && props.ExtratoRange.length > 0 ? (
          <ExtratoList extrato={props.ExtratoRange} hideValues={false} />
        ) : (
          <S.NoDataMessage>Nenhuma movimentação recente</S.NoDataMessage>
        )}
      </S.ExtratoContainer>
    </S.Container>
  );
}

export default connector(HomePage);